"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddleStaticClassName = exports.Paddle = void 0;
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
require("./Paddle.css");
var _paddle = require("@cbhq/cds-common/animation/paddle");
var _tokens = require("@cbhq/cds-common/motion/tokens");
var _tabs = require("@cbhq/cds-common/tokens/tabs");
var _zIndex = require("@cbhq/cds-common/tokens/zIndex");
var _NewAnimatePresence = require("../animation/NewAnimatePresence");
var _IconButton = require("../buttons/IconButton");
var _usePalette = require("../hooks/usePalette");
var _useMotionProps = require("../motion/useMotionProps");
var _gradient = require("../styles/gradient");
var _tokens2 = require("../tokens");
var _linaria = require("../utils/linaria");
var _TabLabel = require("./TabLabel");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const paddleStaticClassName = 'cds-paddle';
exports.paddleStaticClassName = paddleStaticClassName;
const gradientClassName = "cds-gradientClassName-g1oqm7bf";
const paddleClassName = "cds-paddleClassName-pk54omx";
const noEventsClassName = "cds-noEventsClassName-n1czmos0";
const buttonClassName = "cds-buttonClassName-b17pqjdt";
const paddleLeftClassName = "cds-paddleLeftClassName-ptxf26k";
const paddleRightClassName = "cds-paddleRightClassName-p1tjc26m";
// TODO: come up with a better system for handling these custom px values
// Using px are flakey, but I can't think of a more deterministic way to calculate this diff
const tablabelOffset = '7px';
const paddleOffsetClassName = "cds-paddleOffsetClassName-p17zr6dv";
const Paddle = ({
  direction = 'left',
  show,
  background = 'background',
  onPress,
  testID = `${paddleStaticClassName}--${direction}`,
  accessibilityLabel
}) => {
  const palette = (0, _usePalette.usePalette)();
  const className = (0, _linaria.cx)(paddleClassName, paddleOffsetClassName, direction === 'left' ? paddleLeftClassName : paddleRightClassName, show ? null : noEventsClassName);
  const paddleGradientClassName = (0, _linaria.cx)(paddleStaticClassName, _gradient.gradient[direction], gradientClassName);
  const buttonMotionProps = (0, _useMotionProps.useMotionProps)({
    enterConfigs: [Object.assign({}, _paddle.animatePaddleOpacityConfig, {
      toValue: _paddle.paddleVisible
    }), Object.assign({}, _paddle.animatePaddleScaleConfig, {
      toValue: _paddle.paddleVisible,
      delay: _tokens.durations.fast1
    })],
    exitConfigs: [Object.assign({}, _paddle.animatePaddleOpacityConfig, {
      toValue: _paddle.paddleHidden
    }), Object.assign({}, _paddle.animatePaddleScaleConfig, {
      toValue: _paddle.paddleHidden
    })],
    exit: 'exit'
  });
  const gradientMotionProps = (0, _useMotionProps.useMotionProps)({
    enterConfigs: [Object.assign({}, _paddle.animateGradientScaleConfig, {
      toValue: 1
    })],
    exitConfigs: [Object.assign({}, _paddle.animateGradientScaleConfig, {
      toValue: 0
    })],
    exit: 'exit'
  });
  return /*#__PURE__*/_react.default.createElement(_NewAnimatePresence.NewAnimatePresence, null, show && /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    "data-testid": `${testID}--container`,
    style: {
      color: palette[background]
    }
  }, /*#__PURE__*/_react.default.createElement(_framerMotion.m.span, _extends({
    className: buttonClassName
  }, buttonMotionProps), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    accessibilityLabel: accessibilityLabel,
    name: direction === 'left' ? 'caretLeft' : 'caretRight',
    onPress: onPress,
    testID: testID,
    variant: "secondary"
  })), /*#__PURE__*/_react.default.createElement(_framerMotion.m.span, _extends({
    className: paddleGradientClassName
  }, gradientMotionProps))));
};
exports.Paddle = Paddle;
Paddle.displayName = 'Paddle';